import { Box, CommonProps } from '@modusign/design-system';
import { HTMLAttributes } from 'react';

interface DividerProps extends CommonProps, Omit<HTMLAttributes<HTMLHRElement>, 'color'> {}

function Divider({ sx, ...props }: DividerProps) {
  return <Box {...props} sx={{ bg: 'lightGray200', height: '1px', ...sx }} />;
}

export default Divider;
